export const variables = {
  RED_CARDINAL: '#D02129',
  RED_AMARANTH: '#EA384D',
  BLUE_PARIS_SKY: '#03A9F4',
  BLUE_PURE_WATER: '#5DAAE4',
};

export const styles = {
  button: {
    backgroundColor: variables.RED_CARDINAL,
    textTransform: 'capitalize',
    boxShadow: 'none',
    fontWeight: '300',
    margin: '20px 0 0 0',
    fontFamily: 'Proxima Nova',
    '&:hover': {
      backgroundColor: variables.RED_CARDINAL,
    },
    '&:disabled': {
      backgroundColor: variables.RED_CARDINAL,
    },
  },

  title: {
    color: "#555555",
    fontWeight: '600',
    marginBottom: 0,
    fontFamily: 'Proxima Nova',
  },

  successTitle: {
    color: "#555555",
    textAlign: 'center',
    fontSize: '22px',
    margin: '20px 0 20px',
    fontFamily: 'Proxima Nova',
  },

  successBody: {
    color: "#555555",
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '19px',
    fontFamily: 'Proxima Nova',
  },

  ctaButton: {
    backgroundColor: 'white',
    textTransform: 'capitalize',
    boxShadow: 'none',
    fontWeight: '300',
    margin: '40px 0',
    padding: '10px 30px',
    fontFamily: 'Proxima Nova',
    color: variables.RED_CARDINAL,
    border: `solid thin ${variables.RED_CARDINAL}`,
    '&:hover': {
      backgroundColor: variables.RED_CARDINAL,
      color: 'white',
    },
    '&:disabled': {
      backgroundColor: variables.RED_CARDINAL,
      color: 'white',
    },
  },

  loginWithGoogle: {
    backgroundColor: 'white',
    boxShadow: 'none',
    border: 'solid thin rgb(209, 209, 209)',
    textTransform: 'none',
    color: 'rgb(92, 92, 92)',
    padding: '8px 20px',
    margin: '25px 0',
    fontFamily: 'Proxima Nova',
  },

  googleLogo: {
    width: '22px',
    height: '22px',
    marginRight: '15px',
  },

  divider: {
    color: '#D2D2D2',
    fontSize: '12px',
    fontFamily: 'Proxima Nova',
  },

  textfield: {
    marginBottom: '10px',
    fontFamily: 'Proxima Nova',
  },

  formHelperText: {
    textAlign: 'center',
    fontFamily: 'Proxima Nova',
  },

  link: {
    textDecoration: 'none',
    fontFamily: 'Proxima Nova',
    color: variables.BLUE_PARIS_SKY,
    '&:hover': {
      color: variables.BLUE_PURE_WATER,
    }
  },

  forgotPasswordLink: {
    textDecoration: 'none',
    fontFamily: 'Proxima Nova',
    color: variables.BLUE_PARIS_SKY,
    '&:hover': {
      color: variables.BLUE_PURE_WATER,
    },
    fontSize: '13px',
    marginTop: '10px',
    display: 'block',
  },

  buttonCircularProgress: {
    color: '#fff',
  },

  typography: {
    fontFamily: 'Proxima Nova',
  }
};



// WEBPACK FOOTER //
// ./src/styles.js